import MyClub from "./MyClub";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";

const withPageStyles = withStyles(styles);

export default withPageStyles(MyClub);
